import React, { useState } from "react";
import { format } from "date-fns";
import { arEG, enUS, es, fr } from "date-fns/locale";
import { Popover, PopoverContent, PopoverTrigger } from "../UIElements/Popover";
import { Calendar } from "../UIElements/Calendar";
import { Icon } from "../UIElements/Icon";
import { Button } from "../UIElements/Button";
import { cn } from "../../../lib/utils";
import { useUiLocale } from "../../../hooks/useUiLocale";

const CALENDAR_LOCALES = { ar: arEG, en: enUS, es, fr };

const parseLocalDate = (dateStr) => {
  if (!dateStr) return null;
  const [year, month, day] = dateStr.split("-").map(Number);
  return new Date(year, month - 1, day);
};

export const CampaignDatePicker = ({
  value,
  onChange,
  placeholder = "Select date",
  minDate,
  className,
}) => {
  const [open, setOpen] = useState(false);
  const { locale } = useUiLocale();

  const selectedDate = parseLocalDate(value);

  const handleSelect = (date) => {
    if (date) {
      const formattedDate = format(date, "yyyy-MM-dd");
      onChange(formattedDate);
    }
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outlineLight"
          onClick={(e) => e.stopPropagation()}
          className={cn(
            "border-border bg-card focus:ring-ring text-foreground hover:bg-accent flex cursor-pointer items-center gap-2 rounded-md border px-3 py-2 text-sm transition-colors focus:border-transparent focus:ring-2 focus:outline-none",
            className,
          )}
        >
          <Icon name="Calendar" className="text-primary h-4 w-4" />
          <span className={value ? "text-foreground" : "text-muted-foreground"}>
            {value ? format(parseLocalDate(value), "dd/MM/yyyy") : placeholder}
          </span>
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="border-border bg-background w-auto p-0"
        align="start"
        onClick={(e) => e.stopPropagation()}
      >
        <Calendar
          mode="single"
          selected={selectedDate}
          onSelect={handleSelect}
          disabled={minDate ? { before: minDate } : undefined}
          locale={CALENDAR_LOCALES[locale]}
          className="bg-background [&_[data-selected-single=true]]:bg-primary text-foreground [&_[data-selected-single=true]]:text-primary-foreground"
          classNames={{
            today: "ring-2 ring-ring ring-inset rounded-md",
            outside: "text-muted-foreground",
            disabled: "text-muted-foreground opacity-50",
            caption_label: "text-foreground",
            weekdays: "flex justify-between",
            weekday: "text-muted-foreground text-center flex-1 w-8",
          }}
        />
      </PopoverContent>
    </Popover>
  );
};

export default CampaignDatePicker;
